import { callExternalApi } from "../../../services/external-api.service";

class AdminTouchpointHttpClient {
    private _apiServerUrl: string;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }


    async getTouchpointByUuid(accessToken: string, touchpointUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}`,
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }   
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async getTouchpointsByProjectId(accessToken: string, projectId: number) {
        const config = {
            url: `${this._apiServerUrl}/admin/project/${projectId}/touchpoints`,
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async sendTouchpointNotifications(accessToken: string, touchpointUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}/send-notification`,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }

        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async reloadSurveyData(accessToken: string, touchpointUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}/load-survey-data`,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async createTouchpoint(accessToken: string, projectId: number, touchpointData: any) {
        const config = {
            url: `${this._apiServerUrl}/admin/project/${projectId}/touchpoint`,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: touchpointData
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async updateTouchpoint(accessToken: string, projectId: number, touchpointUuid: string, touchpointData: any) {
        const config = {
            url: `${this._apiServerUrl}/admin/project/${projectId}/touchpoint/${touchpointUuid}`,
            method: "PATCH",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: touchpointData
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async getMediaResponseAnalysis(accessToken: string, touchpointUuid: string, forceRegeneration = false) {
        const queryParams = forceRegeneration ? '?force=true' : '';
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}/analyze-media-responses${queryParams}`,
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async regenerateMediaAnalysis(accessToken: string, touchpointUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}/regenerate-media-analysis`,
            method: "POST",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async clearMediaAnalysis(accessToken: string, touchpointUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/touchpoint/${touchpointUuid}/clear-media-analysis`,
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }
}

export default AdminTouchpointHttpClient;